export default __webpack_public_path__ + "images/99d8a767e2822a54dbbac495dc9af4f1.png";